import assets, { getDay } from "src/isf-2025/assets";
import { GRIDPopup } from "src/isf-2025/components/GRID";
import { achievement } from "src/isf-2025/utils";

export default function RightMonitorPopup() {
    const day = getDay()

    const bg = assets.exploration_zone.popups.rightScreen[day]

    return <GRIDPopup roomName="exploration-zone" {...bg} onClickExtra={extra => achievement(extra)}>
        <iframe src={bg.video} 
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            style={{
                position: "absolute",
                width: "84.6%",
                top: "15.7%",
                left: "8%",
                border: "0",
                aspectRatio: "16/9"
            }} 
        />
    </GRIDPopup>
}